//@flow
import {fetchContactSummaryApi, updateContactNameApi} from './api';
import type {ContactSummarySearchParamsFilters} from './api';
import type {ContactSummaryItem} from '../../../entities/crm/contact';
import type {PaginationResponse} from '../../../entities';

export type ContactSummaryFilters = {
  createdFrom?: string,
  createdTo?: string,
  lastMessageDate?: string,
  channel?: string,
  tags?: string[],
  status?: 'OPEN' | 'CLOSED',
  page?: number,
  size?: number,
  name?: string,
};

export function fetchContactSummaryService(
  filters: ContactSummaryFilters = {}
): Promise<PaginationResponse<ContactSummaryItem>> {
  const searchParams: ContactSummarySearchParamsFilters = {
    page: filters.page ?? 0,
    size: filters.size ?? 10,
  };

  if (filters.createdFrom) {
    searchParams.created_from = filters.createdFrom;
  }

  if (filters.createdTo) {
    searchParams.created_to = filters.createdTo;
  }

  if (filters.lastMessageDate) {
    searchParams.last_message_date = filters.lastMessageDate;
  }

  if (filters.channel) {
    searchParams.channel = filters.channel;
  }

  if (filters.tags && filters.tags.length > 0) {
    searchParams.tags = filters.tags.join(',');
  }

  if (filters.status) {
    searchParams.status = filters.status;
  }

  if (filters.name) {
    searchParams.name = filters.name;
  }

  return fetchContactSummaryApi(searchParams).toPromise();
}

export function updateContactNameService(
  identifier: string,
  name: string
): Promise<void> {
  return updateContactNameApi({identifier, name}).toPromise();
}
